/**
 * Fila offline em IndexedDB para apontamentos feitos sem internet.
 * Ao voltar o sinal, o hook OfflineSync envia tudo automaticamente.
 */
import { tx, STORE_QUEUE } from "@/lib/offlineDB";

export async function enqueue(endpoint, payload) {
  await tx(STORE_QUEUE, "readwrite", (store) =>
    store.add({ endpoint, payload, created_at: Date.now(), attempts: 0, last_error: null }),
  );
  window.dispatchEvent(new Event("offline-queue-changed"));
}

export async function getAll() {
  const items = await tx(STORE_QUEUE, "readonly", (store) => store.getAll());
  return items || [];
}

export async function remove(id) {
  await tx(STORE_QUEUE, "readwrite", (store) => store.delete(id));
  window.dispatchEvent(new Event("offline-queue-changed"));
}

export async function updateAttempt(id, error) {
  const item = await tx(STORE_QUEUE, "readonly", (store) => store.get(id));
  if (!item) return;
  item.attempts = (item.attempts || 0) + 1;
  item.last_error = error || null;
  await tx(STORE_QUEUE, "readwrite", (store) => store.put(item));
}

export async function count() {
  return (await tx(STORE_QUEUE, "readonly", (store) => store.count())) || 0;
}

// Envio da fila com trava de reentrância (evita POST duplicado quando
// 'online' e o sync de montagem disparam quase ao mesmo tempo).
let flushing = false;
export async function flushQueue(post, onlyIds = null) {
  if (flushing) return { ok: 0, fail: 0, skipped: true };
  flushing = true;
  let ok = 0, fail = 0;
  try {
    const items = await getAll();
    for (const item of items) {
      if (onlyIds && !onlyIds.includes(item.id)) continue;
      try {
        await post(item.endpoint, item.payload);
        await remove(item.id);
        ok++;
      } catch (e) {
        await updateAttempt(item.id, e?.message || "erro");
        fail++;
      }
    }
  } finally {
    flushing = false;
  }
  return { ok, fail, skipped: false };
}
